import React from "react";
import PublicScheduleGrid from "./PublicScheduleGrid";
import { T } from 'react-translator-component';

// Componente principal
const PublicBookableGrid = ({ day = null, data, paxs, language, handleSelect }) => {

    console.log('paxs', paxs);

    const dayData = data?.find(item => item.date === day);
    console.log('dayData', dayData);
    // Manejar la selección del horario

    function formatDate(dateString) {
        const date = new Date(dateString + " 10:00:00");

        const dayName = date.toLocaleDateString(language, { weekday: "long" });
        const day = date.getDate();
        const monthName = date.toLocaleDateString(language, { month: "long" });
        const year = date.getFullYear();

        // Capitalizar primera letra del día y mes
        const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

        // Formatos por idioma
        switch (language) {
            case 'es':
            case 'es-ES':
                return `${capitalize(dayName)} ${day} de ${monthName} de ${year}`;
            case 'fr':
            case 'fr-FR':
                return `${capitalize(dayName)} ${day} ${monthName} ${year}`;
            case 'it':
            case 'it-IT':
                return `${capitalize(dayName)} ${day} ${monthName} ${year}`;
            case 'de':
            case 'de-DE':
                return `${capitalize(dayName)} ${day}. ${capitalize(monthName)} ${year}`;
            case 'en':
            case 'en-US':
                return `${capitalize(dayName)}, ${capitalize(monthName)} ${day}, ${year}`;
            default:
                return `${capitalize(dayName)} ${day} ${monthName} ${year}`;
        }
    }

    return (
        <div className="d-flex flex-column justify-content-center items-align-center">
            <h5 className="font-bold my-2 py-2 border-bottom capitalize text-center">{formatDate(day)}</h5>
            <div>
                {dayData && (
                    <PublicScheduleGrid
                        date={dayData.date}
                        times={dayData.hours}
                        paxs={paxs}
                        handleHourSelected={handleSelect}
                    />
                )}
                {!dayData && (
                    <div className="d-flex justify-content-center items-align-center">
                        <div className="pt-2 pb-4 mb-4">{T("general.no-schedule-available")}</div>
                    </div>
                )}
            </div>
        </div>

    )
};

export default PublicBookableGrid;